import React, { FC, useMemo } from "react";
import EntityTextVisual from "../text/EntityTextVisual";
import { Validation } from "../../../validation/constants";
import useEntityAnnotation from "../../../../configMap/hooks/useEntityAnnotation";
import { GroupBlockEntityType } from "../../../../configMap";
import { EntityAnnotation } from "../../../../annotation";

import VALIDATIONS_NUMBER from "./validations";
import EditEntityNumber from "./EditEntityNumber";
import EntityValidation from "../../../../configMap/components/entity/EntityValidation";

export type NumberEntityProps = {
  entityType: GroupBlockEntityType;
  entityAnnotation: EntityAnnotation;
  isEditing: boolean;
  isAnnotating: boolean;
  groupBlockIndex: number;
  documentId?: string;
  isTableMode?: boolean;
  // SideControls specific props
  showLabels?: boolean;
  isEditable?: boolean;
  showNormalizedValue?: boolean;
  requiresAttention?: boolean;
  // TableControls specific props
  cellClasses?: string;
};

const NumberEntity: FC<NumberEntityProps> = ({
  entityType,
  entityAnnotation,
  isEditing,
  isAnnotating,
  groupBlockIndex,
  documentId,
  isTableMode = false,
  showLabels = true,
  isEditable = true,
  showNormalizedValue = true,
  requiresAttention = false,
  cellClasses = "",
}) => {
  const { value, normalizedValue, errorType } =
    useEntityAnnotation(entityAnnotation);

  const mergedValidations = useMemo(
    (): Array<Validation> => [...VALIDATIONS_NUMBER],
    [],
  );

  if (!entityAnnotation) {
    return null;
  }

  if (documentId && isEditing && !isAnnotating && isEditable) {
    return (
      <>
        <EditEntityNumber
          entityType={entityType}
          documentId={documentId}
          defaultValue={
            normalizedValue ? parseFloat(normalizedValue) : parseFloat(value)
          }
          annotationId={entityAnnotation.id!}
          groupBlockIndex={groupBlockIndex}
          isTableMode={isTableMode}
        />
        {isEditable && !isTableMode && (
          <EntityValidation
            validationId={`${entityType.entityType.id}-${groupBlockIndex}`}
            value={value}
            normalizedValue={normalizedValue}
            validations={mergedValidations}
            errorType={errorType}
          />
        )}
      </>
    );
  }

  return (
    <>
      <EntityTextVisual
        value={value}
        normalizedValue={normalizedValue}
        showLabels={showLabels}
        showNormalizedValue={showNormalizedValue}
        requiresAttention={requiresAttention}
        errorType={errorType}
        cellClasses={cellClasses}
        isTableMode={isTableMode}
      />
      {isEditable && !isTableMode && (
        <EntityValidation
          validationId={`${entityType.entityType.id}-${groupBlockIndex}`}
          value={value}
          normalizedValue={normalizedValue}
          validations={mergedValidations}
          errorType={errorType}
        />
      )}
    </>
  );
};

export default NumberEntity;
